/**
 * @Author: chengzh
 * @Date:   2021-03-10 18:38:18
 * @Last Modified by:   chengzh
 * @Last Modified time: 2021-06-21 13:46:40
 */
import React, { useState, useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl'
import Router from 'next/router';
import { Button } from 'antd'

import QueryString from 'query-string';
import myContext from '@/utils/createContext';
import LockLoading from '@/components/LockLoading/index';
import {
  getUrlPrefix,
  gtag,
  unzip,
  getUrlParams,
  isEmptyObject,
  reportEventToMonitor
} from '@/utils/index';
import { getCashierData } from '@/components/H5PC/service/index';
import Layout from '@/components/H5PC/Layout/Layout';
import H5PC from '@/components/H5PC/';
import VH5PC from '@/components/H5PC/vIndex';
import { CommonError } from '@/components/H5PC/CommonMethod.js'



function WrapCreditCard(props) {
  const { isMobileView } = props;
  const h5OrWeb = isMobileView ? 'H5' : 'WEB';
  const [resData, setResData] = useState({}); // 初始化数据
  const [loading, setLoading] = useState(true); // loading
  const [key, setKey] = useState(''); // 初始化数据
  const [domain, setDomain] = useState('') // 判断收银台是否为定制

  const [payMethods, setPayMethods] = useState([]); // 支付方式
  const [infoData, setInfoData] = useState({}); // 初始化数据

  // const [payTime, setPayTime] = useState(0); // 储存当前页面时间
  const [lastResponseCode, setLastResponseCode] = useState('');

  useEffect(() => {
    // 解析地址栏data，用于渲染页面
    const queryParams = getUrlParams('paymentData');

    console.log(queryParams);

    const useKey = getUrlParams('key');
    const webDomain = getUrlParams('webDomain');

    setDomain(webDomain)
    // 设置key值
    setKey(useKey)

    // console.log('未命名字段', warning)
    

    const params = unzip(queryParams)
    
    console.log("地址栏信息", JSON.parse(params))

    if (params) { 
      const { payments } = JSON.parse(params) || {}

      setPayMethods(payments);

      setInfoData(JSON.parse(params) || {})
    }
    // 获取初始化数据
    async function fetchData() {
      const urlPrefix = getUrlPrefix();

      // 计算接口耗时
		  const startTime = new Date().getTime();

      // 获取卡组，订单信息
      const res = await getCashierData(useKey); 

      const endTime = new Date().getTime();
      const consumedTime = endTime - startTime;

      consumedTime >= 5000 && reportEventToMonitor(`接口耗时报警(cashier_interface_time): time=${consumedTime}ms; 初始化接口url=/payment/cashier/info/${useKey};`)


      const orderId  = res && res.data && res.data.orderId

      gtag('支付页面', ['订单号：' + orderId]);

      const redirectUrl = res && res.data && res.data.redirectUrl;

      const cancelUrl = JSON.parse(params).cancelUrl || res && res.data && res.data.cancelUrl || document.referrer || '';
      
      if (redirectUrl) {
        if (redirectUrl.indexOf('http') > -1) {
          window.location.href = redirectUrl;
        } else {
          window.location.href = `${urlPrefix}${redirectUrl}`;
        }
      } else {
        if (res?.code === 408001) { 
          sessionStorage.setItem('link', cancelUrl)
          Router.push(`/time-out`);
          return
        }
        if (res?.code === 401005) {
          Router.push(`/referrer-error?code=401005`);
          return
        }
        if (res?.code === 600000) { 
          CommonError(props, isMobileView, setLoading, res, cancelUrl)
          return
        }

        if (res?.code === 990000) { 
          Router.push(`/fail?code=990000`);
          return;
        }

        setResData(res && res.data);
        // 如果用户3ds支付失败，返回需要提示失败原因
        if (res && res.data && res.data.lastResponseCode) {
          setLastResponseCode(res.data.lastResponseCode)
        }
        setLoading(false);
      }
    }
    fetchData();
  }, []);
  return (
    <div
      style={{
        background: '#F8F8F8',
      }}
    >
      {/* paymentData无法解析 && 数据无法加载 */}
      { isEmptyObject(infoData) && loading ? (
        <LockLoading />
      ) : (
        <myContext.Provider value={{ resData, setResData, isMobileView, key, cashierLastResponseCode: lastResponseCode, infoData }}>
          <Layout>
            <VH5PC />
          </Layout>
        </myContext.Provider>
      )}
    </div>
  );
}

export default injectIntl(WrapCreditCard);
